
import { createTheme, Theme } from '@mui/material/styles';

export default function configureTheme() {
  const primaryDark = '#222222';
  const theme: Theme = createTheme({
    palette: {
      primary: {
        main: '#F06922',
        dark: primaryDark,
        contrastText: '#FFFFFF',
      },
    },
    components: {
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            fontSize: '1rem',
            fontWeight: 600,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          containedPrimary: {
            '&:hover': {
              backgroundColor: '#D85A1B',
            },
          },
          textPrimary: {
            color: primaryDark,
            '&:hover': {
              backgroundColor: 'rgba(240, 105, 34, 0.08)',
            },
          },
          outlinedPrimary: {
            color: primaryDark,
            borderColor: '#F06922',
            '&:hover': {
              borderColor: primaryDark,
              backgroundColor: 'rgba(240, 105, 34, 0.08)',
            },
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          outlinedPrimary: {
            color: primaryDark,
            borderColor: '#F06922',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            '&.Mui-selected': {
              color: primaryDark,
            },
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: {
            backgroundColor: '#F06922',
          },
        },
      },
      MuiCheckbox: {
        styleOverrides: {
          root: {
            color: '#F06922',
            '&.Mui-checked': {
              color: '#F06922',
            },
            '&.MuiCheckbox-indeterminate': {
              color: '#F06922',
            },
          },
        },
      },
      MuiRadio: {
        styleOverrides: {
          root: {
            color: '#F06922',
            '&.Mui-checked': {
              color: '#F06922',
            },
          },
        },
      },
    },
  });

  theme.shape.borderRadius = 5;

  return {
    ...theme,
    drawerWidth: 240,
  };
};
